// Intermediary module to break the circular dependency between
// store.js and state_management/*.js files.
//
// store.js imports from state_management (for rootReducer),
// and state_management files need getState() from the store.
// A direct import would create a cycle that fails at eval time.

let _store = null

export function setStore(store) {
  _store = store
}

export function getState() {
  return _store.getState()
}
